@if (contactDetailsForm) {
  <div class="grid-container">
    <form [formGroup]="contactDetailsForm">
      <div class="grid-x grid-margin-x">
        <div class="cell medium-3 flex-align-center">
          @if (canCreateUser) {
            Create User?&nbsp;&nbsp;
            <div class="checkbox">
              <input class="show-for-sr no-margin vertical-align-middle" id="isUser" type="checkbox" formControlName="isUser" (change)="isUserUpdated($event.target.checked)" />
              <label for="isUser" class="minor-margin-right display-inline-block">
                <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
              </label>
            </div>
          } @else {
            Is a User: Yes
          }
        </div>
        <div class="cell medium-3 flex-align-center">
          @if (formValue('isUser')) {
            <div class="checkbox">
              <input class="show-for-sr vertical-align-middle minor-margin-right" id="disableAccount" type="checkbox" formControlName="disableAccount" (ngModelChange)="onUserDisable()">
              <label for="disableAccount" class="minor-margin-right display-inline-block">
                Account Is Disabled: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
              </label>
            </div>
          }
        </div>
        <div class="cell medium-3 flex-align-center">
          <div class="checkbox">
            <input class="show-for-sr no-margin-bottom vertical-align-middle" (click)="toggleIsEntityOrOrganization()" id="isEntityOrOrganization" type="checkbox" formControlName="isEntityOrOrganization">
            <label class="vertical-align-middle minor-margin-right" for="isEntityOrOrganization">Is Entity Or Organization: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span></label>
          </div>
        </div>
        @if (contact.internalContact) {
          <div class="cell medium-3">
            <label>
              <span>Department</span>
              <select formControlName="departmentSelect" [attr.disabled]="isReadOnly() ? 'disabled' : null">
                @for (department of departments; track department) {
                  <option value="{{department.id}}">{{department.displayName}}</option>
                }
              </select>
            </label>
          </div>
        }
      </div>
      @if (canCreateUser) {
        <div class="grid-x grid-margin-x margin-bottom">
          <div class="cell medium-12 flex-item t-align">
            @if (canCreateUser && formValue('isUser')) {
              <div class="error-text">*This action can not be undone.</div>
            }
          </div>
        </div>
      }
      <div class="grid-x grid-margin-x">
        @if (!contact.internalContact) {
          <div class="cell small-12">
            <fieldset class="margin-bottom">
              <legend class="no-margin">Agent Type:</legend>
              <div class="grid-x">
                @for (agent of agentTypes; track agent) {
                  <div [ngClass]="agentCellClass">
                    <div class="checkbox">
                      <input class="show-for-sr no-margin vertical-align-middle" type="checkbox" [attr.id]="agent.text" [attr.disabled]="'disabled'" [checked]="userHasRole(agent.id)"
                        (change)="agentTypesUpdated(agent.id, $event.target.checked)" />
                        <label [for]="agent.text" class="minor-margin-right display-inline-block">
                          <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>  {{agent.text}}
                        </label>
                      </div>
                    </div>
                  }
                </div>
              </fieldset>
            </div>
          }
        </div>
        <div class="grid-x grid-margin-x">
          <div class="cell medium-12">
            <h3>Contact Name</h3>
          </div>
          @if (!contactDetailsForm.controls['isEntityOrOrganization'].value) {
            <div class="cell medium-8">
              <label for="firstNameInput">*First Name:</label>
              <input type="text" id="firstNameInput" formControlName="firstName"
                placeholder="Enter First Name" [attr.disabled]="isReadOnly() ? 'disabled' : null" />
                @if (contactDetailsForm.controls['firstName'].invalid && (contactDetailsForm.controls['firstName'].dirty || contactDetailsForm.controls['firstName'].touched)) {
                  <div class="error-container">
                    @if (contactDetailsForm.get('firstName').hasError('required')) {
                      <small class="error">
                        First
                        name is required
                      </small>
                    }
                  </div>
                }
              </div>
              <div class="cell medium-4">
                <label for="middleInitialInput">M.I.:</label>
                <input type="text" id="middleInitialInput" formControlName="middleInitial"
                  placeholder="M.I." [attr.disabled]="isReadOnly() ? 'disabled' : null" />
                </div>
                <div class="cell medium-8">
                  <label for="lastNameInput">*Last Name:</label>
                  <input type="text" id="lastNameInput" formControlName="lastName"
                    placeholder="Enter Last Name" [attr.disabled]="isReadOnly() ? 'disabled' : null" />
                    @if (contactDetailsForm.controls['lastName'].invalid && (contactDetailsForm.controls['lastName'].dirty || contactDetailsForm.controls['lastName'].touched)) {
                      <div class="error-container">
                        @if (contactDetailsForm.get('lastName').hasError('required')) {
                          <small class="error">
                            Last name
                            is required
                          </small>
                        }
                      </div>
                    }
                  </div>
                  <div class="cell medium-4">
                    <label for="suffixInput">Suffix:</label>
                    <input type="text" id="suffixInput" formControlName="suffix"
                      placeholder="Suffix" [attr.disabled]="isReadOnly() ? 'disabled' : null" />
                    </div>
                    @if (contact.internalContact) {
                      <div class="cell medium-12">
                        <label for="fullLegalName">Full Legal Name:</label>
                        <input type="text" id="fullLegalName" formControlName="fullLegalName" placeholder="Full Legal Name" [attr.disabled]="isReadOnly() ? 'disabled' : null" />
                      </div>
                    }
                  }
                  @if (contactDetailsForm.controls['isEntityOrOrganization'].value) {
                    <div class="cell medium-8">
                      <label for="entityOrOrganizationNameInput">*Entity Or Organization Name:</label>
                      <input type="text" id="entityOrOrganizationNameInput" formControlName="entityOrOrganizationName"
                        placeholder="Enter Entity Or Organization Name"  />
                        @if (contactDetailsForm.controls['entityOrOrganizationName'].invalid && (contactDetailsForm.controls['entityOrOrganizationName'].dirty || contactDetailsForm.controls['entityOrOrganizationName'].touched)) {
                          <div class="error-container">
                            @if (contactDetailsForm.get('entityOrOrganizationName').hasError('required')) {
                              <small class="error">
                                Entity Or Organization Name is required
                              </small>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="grid-x grid-margin-x">
                    <div class="cell medium-12">
                      <h3>Address Information</h3>
                    </div>
                  </div>
                  <div class="grid-x grid-margin-x">
                    <div class="cell medium-8">
                      @if (contactIsOnlyEmergency()) {
                        <label for="addressInput">Address:</label>
                      }
                      @if (!contactIsOnlyEmergency()) {
                        <label for="addressInput">*Address:</label>
                      }
                      <input type="text" id="addressInput" formControlName="address"                        placeholder="Enter Address" />
                        @if (contactDetailsForm.controls['address'].invalid && (contactDetailsForm.controls['address'].dirty || contactDetailsForm.controls['address'].touched)) {
                          <div class="error-container">
                            @if (contactDetailsForm.get('address').hasError('required')) {
                              <small class="error">
                                Address is
                                required
                              </small>
                            }
                          </div>
                        }
                      </div>
                      <div class="cell medium-4">
                        <label for="suiteInput">Suite:</label>
                        <input type="text" id="suiteInput" formControlName="suite"                          placeholder="Suite" />
                        </div>
                      </div>
                      <div class="grid-x grid-margin-x">
                        <div class="cell medium-12">
                          <label for="poBoxInput">P.O. Box (if applicable):</label>
                          <input type="text" id="poBoxInput" formControlName="poBox"                            placeholder="Enter Post Office Box" />
                          </div>
                        </div>
                        <div class="grid-x grid-margin-x">
                          <div class="cell medium-12">
                            @if (contactIsOnlyEmergency()) {
                              <label for="cityInput">City:</label>
                            }
                            @if (!contactIsOnlyEmergency()) {
                              <label for="cityInput">*City:</label>
                            }
                            <input type="text" id="cityInput" formControlName="city"                              placeholder="Enter City" />
                              @if (contactDetailsForm.controls['city'].invalid && (contactDetailsForm.controls['city'].dirty || contactDetailsForm.controls['city'].touched)) {
                                <div class="error-container">
                                  @if (contactDetailsForm.get('city').hasError('required')) {
                                    <small class="error">
                                      City name is
                                      required
                                    </small>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                          <div class="grid-x grid-margin-x">
                            <div class="cell medium-8">
                              @if (states) {
                                @if (contactIsOnlyEmergency()) {
                                  <label for="addressStateCode">State:</label>
                                }
                                @if (!contactIsOnlyEmergency()) {
                                  <label for="addressStateCode">*State:</label>
                                }
                                <select id="addressStateCode" formControlName="addressStateCode" [attr.disabled]="isReadOnly() ? 'disabled' : null">
                                  @for (state of states.values; track state) {
                                    <option [value]="state.Code">{{ state.Definition }}</option>
                                  }
                                </select>
                                @if (contactDetailsForm.controls['addressStateCode'].invalid && (contactDetailsForm.controls['addressStateCode'].dirty || contactDetailsForm.controls['addressStateCode'].touched)) {
                                  <div class="error-container">
                                    @if (contactDetailsForm.get('addressStateCode').hasError('required')) {
                                      <small class="error">
                                        State
                                        is required
                                      </small>
                                    }
                                  </div>
                                }
                              } @else {
                                Loading...
                              }
                            </div>
                            <div class="cell medium-4">
                              @if (contactIsOnlyEmergency()) {
                                <label for="zipCodeInput">Zip Code:</label>
                              }
                              @if (!contactIsOnlyEmergency()) {
                                <label for="zipCodeInput">*Zip Code:</label>
                              }
                              <input type="text" id="zipCodeInput" formControlName="zipCode"                                placeholder="Zip code" />
                                @if (contactDetailsForm.controls['zipCode'].invalid && (contactDetailsForm.controls['zipCode'].dirty || contactDetailsForm.controls['zipCode'].touched)) {
                                  <div class="error-container">
                                    @if (contactDetailsForm.get('zipCode').hasError('required')) {
                                      <small class="error">
                                        Zip code
                                        is required
                                      </small>
                                    }
                                    @if (contactDetailsForm.get('zipCode').hasError('pattern')) {
                                      <small class="error">
                                        Zip code is
                                        invalid
                                      </small>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="grid-x grid-margin-x">
                              <div class="cell medium-12">
                                <h3>Contact Information</h3>
                              </div>
                            </div>
                            <div class="grid-x grid-margin-x">
                              <div class="cell medium-6" >
                                <label for="emailAddressInput">*Email Address:</label>
                                <input autocomplete="new-password" type="text" id="emailAddressInput" formControlName="emailAddress"                                  placeholder="Enter Email Address" />
                                  @if (contactDetailsForm.controls['emailAddress'].invalid && (contactDetailsForm.controls['emailAddress'].dirty || contactDetailsForm.controls['emailAddress'].touched)) {
                                    <div class="error-container">
                                      @if (contactDetailsForm.get('emailAddress').hasError('required')) {
                                        <small class="error">
                                          Email
                                          Address is required
                                        </small>
                                      }
                                      @if (contactDetailsForm.get('emailAddress').hasError('pattern')) {
                                        <small class="error">
                                          Email
                                          is invalid
                                        </small>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="cell medium-6">
                                  <label for="primaryPhoneInput">* Primary Phone:</label>
                                  <phonenumber-input id="primaryPhoneInput" formControlName="primaryPhone"></phonenumber-input>
                                  @if (contactDetailsForm.controls['primaryPhone'].invalid && (contactDetailsForm.controls['primaryPhone'].dirty || contactDetailsForm.controls['primaryPhone'].touched)) {
                                    <div class="error-container">
                                      @if (contactDetailsForm.get('primaryPhone').hasError('required')) {
                                        <small class="error">
                                          Primary
                                          phone number is required
                                        </small>
                                      }
                                      @if (contactDetailsForm.get('primaryPhone').hasError('pattern')) {
                                        <small class="error">
                                          Phone
                                          is invalid
                                        </small>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="grid-x grid-margin-x">
                                <div class="cell medium-6">
                                  <label for="secondaryPhoneInput">Secondary Phone:</label>
                                  <phonenumber-input id="secondaryPhoneInput" formControlName="secondaryPhone"></phonenumber-input>
                                  @if (contactDetailsForm.controls['secondaryPhone'].invalid && (contactDetailsForm.controls['secondaryPhone'].dirty || contactDetailsForm.controls['secondaryPhone'].touched)) {
                                    <div class="error-container">
                                      @if (contactDetailsForm.get('secondaryPhone').hasError('pattern')) {
                                        <small class="error">
                                          Phone
                                          is invalid
                                        </small>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="cell medium-6">
                                  <label for="faxInput">Fax:</label>
                                  <phonenumber-input id="faxInput" formControlName="fax"></phonenumber-input>
                                  @if (contactDetailsForm.controls['fax'].invalid && (contactDetailsForm.controls['fax'].dirty || contactDetailsForm.controls['fax'].touched)) {
                                    <div class="error-container">
                                      @if (contactDetailsForm.get('fax').hasError('pattern')) {
                                        <small class="error">Fax is invalid</small>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              @if (isInternal) {
                                <div class="grid-x grid-margin-x">
                                  <div class="cell medium-12">
                                    <h3>Certified Mail Credentials</h3>
                                  </div>
                                  <div class="cell medium-6">
                                    <label for="certifiedMailId">Certified Mail Login Id:</label>
                                    <input type="text" formControlName="certifiedMailId" id="certifiedMailId" [attr.disabled]="isReadOnly() ? 'disabled' : null"/>
                                  </div>
                                  <div class="cell medium-6">
                                    <label for="certifiedMailLogin">Certified Mail Password:</label>
                                    <input autocomplete="new-password" type="password" formControlName="certifiedMailLogin" id="certifiedMailLogin" [attr.disabled]="isReadOnly() ? 'disabled' : null"/>
                                  </div>
                                </div>
                              }
                              @if (isInternal) {
                                <div>
                                  <admin-group-selector [group-title]="'Available Groups'" [selected-title]="'Contact Belongs To'" [available-title]="'Available Groups'" [elements]="availableGroups" [initial-set]="userGroups" (changed)="updateMembership($event)"></admin-group-selector>
                                </div>
                              }
                            </form>
                          </div>
                        }
